export enum FeatureKey {
	Reservation = 'reservation',
	Kitchen = 'kitchen',
	Statistics = 'statistics',
	WhatsApp = 'whatsApp',
}

export interface IFeaturesSettings {
	reservation: boolean
	kitchen: boolean
	statistics: boolean
	whatsApp: boolean
}
